import React from "react";
import { useApp } from "../../hooks/app-context";
import { useConfig } from "../../hooks/config-context";
import { HeadingComponent } from "../shared/HeadingComponent";
import { ImageComponent } from "../shared/ImageComponent";
import { LinkComponent } from "../shared/LinkComponent";
import { SubHeadingComponent } from "../shared/SubHeadingComponent";
import { TextComponent } from "../shared/TextComponent";
import { useTranslation } from "react-i18next";
const AuthLayoutWrapperComponent = ({
  children,
  heading,
  subHeading,
  showPrivacyPolicy = true
}) => {
  const app = useApp();
  const {
    copyrightFooter
  } = useConfig();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pt-12 md:pt-24 min-h-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-12 flex justify-center"
  }, /*#__PURE__*/React.createElement(ImageComponent, {
    src: app.logo
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 md:mt-8 text-center"
  }, /*#__PURE__*/React.createElement(HeadingComponent, {
    size: "4xl",
    type: "h1"
  }, heading), /*#__PURE__*/React.createElement(SubHeadingComponent, {
    type: "secondary",
    size: "lg",
    className: "font-normal mt-3"
  }, subHeading)), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 flex items-center flex-col"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "mt-auto mx-auto text-center mb-6"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm"
  }, copyrightFooter)), showPrivacyPolicy && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkComponent, {
    type: "primary",
    to: app.privacyPolicyUrl,
    nativeBehavior: true,
    target: "_blank",
    size: "sm",
    className: "font-semibold"
  }, t("Privacy policy")))));
};
export { AuthLayoutWrapperComponent };